import { Image, Stack } from "@mantine/core";
import { getAssetUrl } from "@utils/getAssetUrl";
import { useAppNavigate } from "@/apps/global/navigate/navigate";
import { useUserEvent } from "@/apps/@hooks/useUserEvent";
import { useEffect, useState } from "react";
import { useWaitingInPage } from "@/apps/@hooks/useWaitingInPage";

export default function EcSeriesPage() {
	const { navigateToEcSeries } = useAppNavigate();
	const { logPage, logEvent } = useUserEvent();
	const seriesEventData = [
		"icon",
		"forget",
		"moondance",
		"pierced",
		"curiosity",
		"gemini",
		"runway",
	];

	useEffect(() => {
		logPage({
			path: "/homepage",
		});
	}, []);

	useWaitingInPage({
		getPath: () => `/homepage`,
		logEvent,
	});
	return (
		<Stack gap="6.4vw">
			<Stack justify="center" align="center" gap="3vw">
				<video
					playsInline
					muted
					autoPlay
					loop
					preload="metadata"
					style={{ width: "100%", height: "auto", display: "block" }}
				>
					<source src={getAssetUrl("/videos/top-title.mp4")} type="video/mp4" />
				</video>
				<Image
					src={getAssetUrl(
						"/images/ec-campaign/home-page/description-text.jpg",
					)}
					alt="description-text"
				/>
			</Stack>
			{Array.from({ length: 7 }, (_, i) => i + 1).map((index) => (
				<Stack key={index} gap="3vw">
					{index === 6 ? (
						<Stack
							pos="relative"
							h="57.22vw"
							w="100%"
							align="center"
							onClick={() => {
								logEvent({
									category: "cta",
									path: "/homepage",
									action: seriesEventData[index - 1],
									event: "cta_" + seriesEventData[index - 1],
								});
								navigateToEcSeries(index);
							}}
						>
							<Image
								src={getAssetUrl(
									"/images/ec-campaign/home-page/explore-text.jpg",
								)}
								w="19.59vw"
								h="7.73vw"
								alt="explore-text"
								pos="absolute"
								bottom="8%"
								style={{
									zIndex: 1,
								}}
							/>
							<video
								playsInline
								muted
								autoPlay
								loop
								preload="metadata"
								style={{
									width: "100%",
									height: "100%",
									display: "block",
									objectFit: "cover",
								}}
							>
								<source
									src={getAssetUrl("/videos/gemini-series.mp4")}
									type="video/mp4"
								/>
							</video>
						</Stack>
					) : (
						<Image
							src={getAssetUrl(
								`/images/ec-campaign/home-page/explore-series${index}.jpg`,
							)}
							alt="series-product-list"
							onClick={() => {
								logEvent({
									category: "cta",
									path: "/homepage",
									action: seriesEventData[index - 1],
									event: "cta_" + seriesEventData[index - 1],
								});
								navigateToEcSeries(index);
							}}
						/>
					)}
					<Image
						src={getAssetUrl(
							`/images/ec-campaign/home-page/explore-series-title${index}.jpg`,
						)}
						alt="series-product-list"
					/>
				</Stack>
			))}
		</Stack>
	);
}
